import { render, staticRenderFns } from "./fapiao.vue?vue&type=template&id=8a0c5b3c&scoped=true"
import script from "./fapiao.vue?vue&type=script&lang=js"
export * from "./fapiao.vue?vue&type=script&lang=js"
import style0 from "./fapiao.vue?vue&type=style&index=0&id=8a0c5b3c&prod&lang=less"
import style1 from "./fapiao.vue?vue&type=style&index=1&id=8a0c5b3c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8a0c5b3c",
  null
  
)

export default component.exports